/**
 * Scroll to top
 */

const scrollTop = () => {
  const btnTop = document.querySelector('.js-scroll-top');

  if (!btnTop) return;

  // Show/hide button based on scroll position
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      btnTop.classList.add('is-scrolled');
    } else {
      btnTop.classList.remove('is-scrolled');
    }
  });

  // Scroll to top on click
  btnTop.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
};

export default scrollTop;
